import { SpaceUserGroup } from '../types/spaceUserGroups';
import { Dictionary } from '@onaio/utils';

// Action Types
export const SET_SPACE_USER_GROUPS = 'SET_SPACE_USER_GROUPS';
export const SET_LOADING = 'SET_LOADING';
export const SET_ERROR = 'SET_ERROR';
export const ADD_GROUP = 'ADD_GROUP';
export const UPDATE_GROUP = 'UPDATE_GROUP';
export const REMOVE_GROUP = 'REMOVE_GROUP';

// Action Creators
export const setSpaceUserGroups = (groups: SpaceUserGroup[]) => ({
  type: SET_SPACE_USER_GROUPS,
  payload: groups,
});

export const setLoading = (loading: boolean) => ({
  type: SET_LOADING,
  payload: loading,
});

export const setError = (error: string | null) => ({
  type: SET_ERROR,
  payload: error,
});

export const addGroup = (group: SpaceUserGroup) => ({
  type: ADD_GROUP,
  payload: group,
});

export const updateGroup = (group: SpaceUserGroup) => ({
  type: UPDATE_GROUP,
  payload: group,
});

export const removeGroup = (groupId: string) => ({
  type: REMOVE_GROUP,
  payload: groupId,
});

// Initial State
const initialState = {
  groups: [] as SpaceUserGroup[],
  loading: false,
  error: null as string | null,
};

// Reducer
export default function reducer(state = initialState, action: Dictionary) {
  switch (action.type) {
    case SET_SPACE_USER_GROUPS:
      return {
        ...state,
        groups: action.payload,
      };
    case SET_LOADING:
      return {
        ...state,
        loading: action.payload,
      };
    case SET_ERROR:
      return {
        ...state,
        error: action.payload,
      };
    case ADD_GROUP:
      return {
        ...state,
        groups: [...state.groups, action.payload],
      };
    case UPDATE_GROUP:
      return {
        ...state,
        groups: state.groups.map((group: SpaceUserGroup) =>
          group.id === action.payload.id ? action.payload : group
        ),
      };
    case REMOVE_GROUP:
      return {
        ...state,
        groups: state.groups.filter((group: SpaceUserGroup) => group.id !== action.payload),
      };
    default:
      return state;
  }
} 